import apiClient from '@/lib/apiClient';

const BASE = '/admin/permissions';

export interface AdminPermissionRecord {
  id: number;
  key: string;
  resource?: string | null;
  action?: string | null;
  description?: string | null;
}

export const permissionApi = {
  list: async (): Promise<AdminPermissionRecord[]> => {
    const res = await apiClient.get(BASE);
    const data = res.data?.data ?? res.data;
    return Array.isArray(data) ? data : [];
  },
};
